<template>
  <div>
    <DashboardTemplate>
      <ActiveActivitiesNav
        v-bind:nav="{
          dashboard:false,
          activity:false,
          milestone:false,
          document:true
        }"
        v-if="getRule === 'admin' || getRule === 'exclusiveboard' || getRule === 'staff'"
      />
      <DocumentActivities/>
    </DashboardTemplate>
  </div>
</template>
/* eslint-disable */
<script>
// @ is an alias to /src
import DashboardTemplate from '@/template/DashboardTemplate.vue';
import ActiveActivitiesNav from '@/components/ActiveActivitiesNav.vue';
import DocumentActivities from '@/components/DocumentActivities.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'dashboard',
  components: {
    DashboardTemplate,
    ActiveActivitiesNav,
    DocumentActivities,
  },
  computed: {
    ...mapGetters([
      'getRule',
    ]),
  },
};
</script>

<style scoped>
    .columns{display: -webkit-box!important;}
</style>
